<template lang="pug">
  v-container(grid-list-md v-if="!$root.$children[0].loading")
    v-flex(md12)
      v-card.elevation-12

        v-toolbar(dark color="primary" dense)
          v-toolbar-title Servicio {{ $route.params.IDPay }}
          v-spacer
          v-btn(@click="$router.go(-1)" flat)
            | Volver
            v-icon(right) undo
          v-btn(@click="closeSession()" flat)
            | Cerrar sesión
            v-icon(right) power_settings_new

        v-card-text
          v-layout(row wrap)
            table(width="100%" align="center").mb-3
              thead
                tr
                  th(height="30") Asignado por
                  th ID de pago
                  th Tipo
                  th Valor servicio
                  th Hora de cierre
              tbody
                tr
                  td(align="center" height="40") {{ service.assigned_by }}
                  td(align="center") {{ service.id_pay }}
                  td(align="center") {{ service.type }}
                  td(align="center") {{ service.value | price }}
                  td(align="center") {{ service.hour_end }}

            table(width="100%" align="center")
              thead
                tr
                  th(width="40") Nro
                  th(width="240") Nombre
                  th Dirección
                  th(width="120") Comuna
                  th(width="80") Hora de retiro
                  th(width="80") Estado
                  th(width="80") Hora de llegada
                  th(width="80") Tiempo de espera
                  th(width="80") GPS Movil
                  th(width="80") Hora de servicio
                  th Observaciones
              tbody
                tr(v-for="(passenger, index) in service.passengers").hover-highlighter
                  td(align="center") {{ passenger.number }}
                  td(align="center") {{ passenger.name }}
                  td(align="center") {{ passenger.address }}
                  td(align="center") {{ passenger.commune }}
                  td(align="center") {{ passenger.hour }}
                  td(align="center"): img(:src="stateImage(passenger.state_movil, service.type, passenger.transfer)" width=28)
                  td(align="center" :style="bgSynoptic[index]") {{ passenger.check_in }}
                  td(align="center") {{ passenger.chronometer_timer }}
                  td(align="center"): v-btn(fab small @click.native="showMaps(passenger.localization_movil, passenger.localization)"): v-icon map
                  td(align="center") {{ passenger.chronometer_save }}
                  td(align="center") {{ passenger.commentary }}

            table(width="100%" align="center")
              thead

    v-dialog(v-model='showMapsDialog' width='550')
      v-card
        v-card-text
          gmap-map(:center='getMapPositionDriver' :zoom='15' style='width: 100%; height: 400px')
             gmap-marker(:position='getMapPositionDriver' :clickable='true' :draggable='true' :icon="pinMovil")
             gmap-marker(:position='getMapPositionPassenger' :clickable='true' :draggable='true' :icon="pinPassenger")
        v-divider
        v-card-actions
          v-spacer
          v-btn(flat @click="showMapsDialog = false") Cerrar

    v-flex(md6 v-if="typeof service.driver === 'object'").mt-5.ml-auto.mr-auto
      v-card.elevation-12
        v-toolbar(dark color="primary" dense)
          v-toolbar-title Conductor asignado: {{ service.driver.n_movil }} - {{ service.driver.turn }}
        v-card-text
          v-layout(row wrap)
            v-flex(md6)
              img.driver-picture(:src="service.driver.picture" width="100%")
            v-flex.driver(md6)
              ._title Nombre:
              ._description {{ service.driver.name }}

              ._title Marca:
              ._description {{ service.vehicle.marca }}

              ._title Modelo:
              ._description {{ service.vehicle.model }}

              ._title Color:
              ._description {{ service.vehicle.color }}

              ._title Placa Patente:
              ._description {{ service.driver.patente }}

</template>

<script>
  import np from '@/assets/NP.png'
  import ok from '@/assets/OK.png'
  import psc from '@/assets/PSC.png'
  import pinMovil from '@/assets/pin-movil.png'
  import pinPassenger from '@/assets/pin-passenger.png'
  import moment from 'moment'

  export default {
    name: 'service',
    data: () => ({
      showMapsDialog: false,
      service: [],
      mapPositionDriver: '',
      mapPositionPassenger: '',
      pinMovil: pinMovil,
      pinPassenger: pinPassenger
    }),
    created () {
      this.$root.$children[0].loading = true
      this.$http.get('service/' + this.$route.params.IDPay, {
        params: {
          vehicleID: localStorage.getItem('vehicleID')
        }
      }).then(res => {
        this.service = res.body
        this.$root.$children[0].loading = false
      }).catch(res => {
        this.$router.push('/')
        this.$root.$children[0].loading = false
      })
    },
    methods: {
      stateImage (state, type, transfer) {
        if (type === 'rtx_zarpe' || type === 'zarpe') {
          if (transfer) {
            return ok
          } else {
            return np
          }
        } else {
          if (state === 'on-your-own') return psc
          else if (state === 'on-route') return ok
          else return np
        }
      },
      showMaps (positionDriver, positionPassenger) {
        this.mapPositionDriver = positionDriver
        this.mapPositionPassenger = positionPassenger
        this.showMapsDialog = true
      }
    },
    computed: {
      getMapPositionDriver () {
        if (!this.mapPositionDriver || this.mapPositionDriver.search(',') === -1) return this.getMapPositionPassenger
        let location = this.mapPositionDriver.split(',')
        return {
          lat: parseFloat(location[0]),
          lng: parseFloat(location[1])
        }
      },
      getMapPositionPassenger () {
        if (!this.mapPositionPassenger || this.mapPositionPassenger.search(',') === -1) return { lat: 0, lng: 0 }
        let location = this.mapPositionPassenger.split(',')
        return {
          lat: parseFloat(location[0]),
          lng: parseFloat(location[1])
        }
      },
      bgSynoptic () {
        let bgs = []
        if (this.service.type === 'reco') {
          this.service.passengers.forEach(passenger => {
            let duration = moment.duration(moment(passenger.hour, 'HH:mm').diff(moment(passenger.check_in, 'HH:mm'))).asMilliseconds()
            if (duration === 0) {
              bgs.push({
                backgroundColor: 'yellow'
              })
            } else if (duration > 0) {
              bgs.push({
                backgroundColor: 'green',
                color: 'white'
              })
            } else {
              bgs.push({
                backgroundColor: 'red',
                color: 'white'
              })
            }
          })
        }
        return bgs
      }
    }
  }
</script>

<style lang="sass">
  .driver
    > ._title
      text-transform: uppercase
      font-size: 11px
      letter-spacing: 2px
      font-weight: 600
    > ._description
      font-size: 16px
      margin-bottom: 10px
  .driver-picture
    max-width: 200px
    display: block
    margin: auto
</style>



// WEBPACK FOOTER //
// src/pages/service.vue